import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("nayara_token");
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setPermissions(data.permissions || {});
    } catch {
      localStorage.removeItem("nayara_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("nayara_token", data.token);
    setUser(data.user);
    setPermissions(data.permissions || {});
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("nayara_token");
    setUser(null);
    setPermissions({});
    window.location.href = "/login";
  };

  const can = useCallback((module, action = "view") => {
    if (!user) return false;
    if (user.role === "admin") return true;
    return (permissions[module] || []).includes(action);
  }, [user, permissions]);

  return (
    <AuthContext.Provider value={{ user, permissions, loading, login, logout, can, refresh: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
